import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { PaddleDuelSpec } from "./spec";

export function repairCommandsForPaddleDuel(spec: PaddleDuelSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  if (!failed.size) return null;
  const params: Record<string, number> = {};
  if (failed.has("touch-target")) params.paddleHeight = 100;
  if (failed.has("match-terminates") || failed.has("player-winnable")) {
    params.aiSpeed = Math.max(90, Math.round(spec.params.aiSpeed / 2));
  }
  if (failed.has("point-scorable")) {
    // Two-player mode: a point must be scorable against a perfect tracker;
    // a faster ball is what beats tracking on a symmetric arena.
    params.ballSpeed = 600;
  }
  return Object.keys(params).length ? [{ type: "set-params", params }] : null;
}
